// Returns the URL a given notification should navigate to.
// Returns null if the notification points nowhere useful (e.g., missing deal id).
//
// Notification types in use:
//   - "newtask"               → task assignment on a deal
//   - "deadline"              → task deadline reminder
//   - "mention"               → chat or note mention on a deal
//   - "pending-approval"      → sale turn-in needing review
//   - "pending-file"          → file request needing creation
//   - "approved-for-accounting" → deal approved, accountants notified
//   - "file-completed"        → requesting agent informed file is ready
//   - "post-reaction"         → reaction on a Feed post (NOT a deal id)
export function urlForNotification(n) {
  if (!n) return null;

  // Feed post reactions: the `dealid` field actually holds the post id.
  if (n.type === "post-reaction") {
    return "/dashboard/feed";
  }

  // Everything else is deal-scoped.
  if (!n.dealid) return null;

  if (n.type === "mention") {
    return `/dashboard/deals-detail/${n.dealid}?type=chat`;
  }

  if (n.type === "newtask" || n.type === "deadline") {
    const taskQuery = n.taskid ? `taskId=${n.taskid}` : "";
    return `/dashboard/deals-detail/${n.dealid}${taskQuery ? `?${taskQuery}` : ""}`;
  }

  return `/dashboard/deals-detail/${n.dealid}`;
}
